<template>
  <div :class="cssClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: false
    },
    variant: {
      type: String,
      required: false
    }
  },
  computed: {
    cssClass() {
      return {
        'c-alert': true,
        ['c-alert--' + this.size]: this.size,
        ['c-alert--' + this.variant]: this.variant
      };
    }
  }
};
</script>
